"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomHeader = exports.ConnectionKeepAlive = exports.ConnectionClose = exports.getConnectionHeader = void 0;
function getConnectionHeader() {
    return `connection`;
}
exports.getConnectionHeader = getConnectionHeader;
function ConnectionClose() {
    return `close`;
}
exports.ConnectionClose = ConnectionClose;
function ConnectionKeepAlive() {
    return `keep-alive`;
}
exports.ConnectionKeepAlive = ConnectionKeepAlive;
function getCustomHeader(name) {
    return `x-${name}`;
}
exports.getCustomHeader = getCustomHeader;
